import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import StructuredData from '../../components/feature/StructuredData';

const EmpresaPage = () => {
  useEffect(() => {
    document.title = 'Empresa - ECOSERVEIS | Especialistas en Vaciado de Locales Barcelona';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Conoce ECOSERVEIS, empresa especializada en vaciado de locales comerciales Barcelona. Profesionales con experiencia en retirada de mobiliario y gestión de residuos. ☎ 644 613 451');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Conoce ECOSERVEIS, empresa especializada en vaciado de locales comerciales Barcelona. Profesionales con experiencia en retirada de mobiliario y gestión de residuos. ☎ 644 613 451';
      document.head.appendChild(meta);
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'empresa vaciado locales Barcelona, profesionales vaciado naves, retirada mobiliario comercial, gestión residuos Barcelona');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'empresa vaciado locales Barcelona, profesionales vaciado naves, retirada mobiliario comercial, gestión residuos Barcelona';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <>
      <StructuredData type="home" />
      <Header />
      <WhatsAppButton />
      
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 lg:pt-36 lg:pb-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-5 gap-12 items-center">
              {/* Imagen Izquierda */}
              <div className="lg:col-span-2">
                <div className="inline-flex items-center px-4 py-2 bg-white border border-gray-200 rounded-full mb-6">
                  <span className="text-sm font-medium text-gray-700">Sobre Nosotros</span>
                </div>
                <div className="rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src="https://public.readdy.ai/ai/img_res/b99d6897743cb3848f867b81ff5abc08.jpg"
                    alt="Equipo profesional ECOSERVEIS"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Contenido Derecha */}
              <div className="lg:col-span-3">
                <h1 className="font-['Sora'] text-5xl font-bold text-gray-900 leading-tight mb-6">
                  Profesionales del<br />
                  vaciado de locales en<br />
                  Barcelona
                </h1>
                <div className="space-y-4 text-lg text-gray-600 leading-relaxed mb-8">
                  <p>
                    <strong>ECOSERVEIS</strong> es una empresa especializada en <strong>vaciado de locales Barcelona</strong>, naves industriales y oficinas. Con sede en L'Hospitalet de Llobregat, ofrecemos un <Link to="/servicios" className="text-[#FF6B35] hover:underline">servicio profesional, rápido y completamente legal</Link> en toda Barcelona y provincia.
                  </p>
                  <p>
                    Nuestro equipo cuenta con amplia experiencia en <strong>vaciado de locales comerciales</strong>, <strong>retirada de mobiliario comercial</strong> y <strong>desmontaje de estanterías</strong> y mostradores. Trabajamos con propietarios, inmobiliarias, administradores de fincas y empresas que necesitan vaciar espacios por cierre, traspaso, fin de alquiler o reforma.
                  </p>
                  <p>
                    Nos diferenciamos por nuestra profesionalidad, puntualidad y compromiso con la gestión responsable de residuos. Todos los materiales retirados son gestionados según la normativa vigente, separando reciclables y llevando enseres reutilizables a puntos de donación cuando es posible. <Link to="/faq" className="text-[#FF6B35] hover:underline">Resuelve tus dudas en nuestras preguntas frecuentes</Link>.
                  </p>
                </div>
                <a
                  href="tel:+34644613451"
                  className="inline-flex items-center px-7 py-3.5 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Contactar Ahora
                  <div className="w-5 h-5 flex items-center justify-center ml-2">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Valores */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-4">
                Nuestros valores
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Principios que guían nuestro trabajo diario en cada servicio de <strong>vaciado de oficinas</strong> y locales
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-2xl mx-auto mb-4">
                  <i className="ri-shield-check-line text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Profesionalidad</h3>
                <p className="text-gray-600">
                  Equipo cualificado con experiencia en todo tipo de vaciados comerciales e industriales. <Link to="/servicios" className="text-[#FF6B35] hover:underline">Ver todos nuestros servicios</Link>.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-2xl mx-auto mb-4">
                  <i className="ri-time-line text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Rapidez</h3>
                <p className="text-gray-600">
                  Servicio urgente en 24-48h según disponibilidad. Nos adaptamos a tus plazos. <Link to="/contacto" className="text-[#FF6B35] hover:underline">Solicita presupuesto</Link>.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-2xl mx-auto mb-4">
                  <i className="ri-file-list-3-line text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Legalidad</h3>
                <p className="text-gray-600">
                  Gestión de residuos conforme a normativa. Factura completa de todos los servicios
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-2xl mx-auto mb-4">
                  <i className="ri-leaf-line text-4xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sostenibilidad</h3>
                <p className="text-gray-600">
                  Separación de reciclables y donación de enseres reutilizables siempre que es posible
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Forma de Trabajar */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-6">
                  Cómo trabajamos en cada servicio
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-phone-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Contacto Inicial</h3>
                      <p className="text-gray-600">
                        Nos cuentas tu necesidad por teléfono o WhatsApp. Recogemos información básica sobre el local, nave u oficina a vaciar.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-camera-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Valoración</h3>
                      <p className="text-gray-600">
                        Visitamos el espacio o valoramos con fotos detalladas. Evaluamos volumen, accesos, desmontajes necesarios y particularidades.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-file-text-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Presupuesto Sin Compromiso</h3>
                      <p className="text-gray-600">
                        Entregamos presupuesto detallado y transparente. Explicamos qué incluye el servicio y resolvemos todas tus dudas.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-calendar-check-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Coordinación</h3>
                      <p className="text-gray-600">
                        Acordamos fecha y horario según tu disponibilidad y normativas de la comunidad. Gestionamos permisos si son necesarios.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-truck-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Ejecución</h3>
                      <p className="text-gray-600">
                        Realizamos el vaciado completo con nuestro equipo y vehículos. Desmontamos lo necesario y gestionamos todos los residuos legalmente.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-lg mr-4 flex-shrink-0">
                      <i className="ri-checkbox-circle-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">Entrega y Factura</h3>
                      <p className="text-gray-600">
                        Dejamos el espacio vacío y limpio (con limpieza opcional). Entregamos factura completa del servicio realizado.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=loading%20furniture%20van%20Barcelona&width=600&height=750&seq=empresa-work-001&orientation=portrait"
                    alt="Proceso de trabajo ECOSERVEIS"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Coordinación con Profesionales */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="font-['Sora'] text-4xl font-bold text-gray-900 mb-4">
                Trabajamos con profesionales del sector
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Colaboramos habitualmente con inmobiliarias, administradores de fincas y empresas que necesitan servicios de <strong>vaciado de naves industriales Barcelona</strong> y locales comerciales
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-4 shadow-md">
                  <i className="ri-building-4-line text-3xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Inmobiliarias</h3>
                <p className="text-gray-600">
                  Vaciamos locales para nuevos arrendamientos o ventas. Nos coordinamos con vuestros plazos y requisitos específicos. <Link to="/servicios" className="text-[#FF6B35] hover:underline">Conoce nuestros servicios especializados</Link>.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-4 shadow-md">
                  <i className="ri-community-line text-3xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Administradores</h3>
                <p className="text-gray-600">
                  Gestionamos vaciados de locales en comunidades, respetando horarios y normativas de cada finca. <Link to="/faq" className="text-[#FF6B35] hover:underline">Consulta preguntas frecuentes</Link>.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-4 shadow-md">
                  <i className="ri-briefcase-4-line text-3xl text-[#FF6B35]"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Empresas</h3>
                <p className="text-gray-600">
                  Vaciado de oficinas por traslados, cierres o reestructuraciones. Servicio discreto y profesional. <Link to="/contacto" className="text-[#FF6B35] hover:underline">Contacta con nosotros</Link>.
                </p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <p className="text-lg text-gray-600 mb-6">
                ¿Necesitas un servicio de <strong>vaciado de locales comerciales</strong> para tu cartera de inmuebles? <Link to="/" className="text-[#FF6B35] hover:underline">Descubre por qué somos tu mejor opción</Link>.
              </p>
              <a
                href="tel:+34644613451"
                className="inline-flex items-center px-8 py-4 bg-[#FF6B35] text-white text-lg font-semibold rounded-lg hover:bg-[#E55A2B] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line"></i>
                </div>
                Contactar: 644 613 451
              </a>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-['Sora'] text-4xl font-bold mb-6">
              Confía en profesionales con experiencia
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Más de mil servicios realizados en Barcelona y provincia. Vaciado de locales, naves y oficinas con garantía de profesionalidad y legalidad. <Link to="/servicios" className="text-white hover:text-gray-200 underline">Ver todos nuestros servicios</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+34644613451"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#FF6B35] text-white text-lg font-semibold rounded-lg hover:bg-[#E55A2B] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-fill"></i>
                </div>
                Llamar Ahora
              </a>
              <a
                href="https://wa.me/34644613451"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-whatsapp-line"></i>
                </div>
                WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default EmpresaPage;